import AbstractPosition from './AbstractPosition';

class WellPosition extends AbstractPosition{}

export default WellPosition;